import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SecurityHeaders Component
 * 
 * This component applies basic security headers using react-helmet-async.
 * Note: Content-Security-Policy and X-Frame-Options are removed from meta tags
 * as they should be set via actual HTTP headers on the server for proper functionality.
 */
const SecurityHeaders = () => {
  return (
    <Helmet>
      {/* Prevent MIME type sniffing */}
      <meta 
        http-equiv="X-Content-Type-Options" 
        content="nosniff" 
      />
      
      {/* XSS protection */}
      <meta 
        http-equiv="X-XSS-Protection" 
        content="1; mode=block" 
      />
      
      {/* Referrer Policy */}
      <meta
        name="referrer"
        content="strict-origin-when-cross-origin"
      />
      
      {/* Feature Policy / Permissions Policy */}
      <meta 
        http-equiv="Permissions-Policy" 
        content="camera=(), microphone=(), geolocation=(self), payment=()" 
      />
    </Helmet>
  );
};

export default SecurityHeaders;
